module.exports = __webpack_public_path__ + "static/media/smile_yellow.5213c3f7.svg";